import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Logged from '@/components/Logged'
import Products from '@/components/Products'
import Form from '@/components/Form'
import FormPurchaseCode from '@/components/FormPurchaseCode'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Hello',
            component: HelloWorld
        },
        {
            path: '/products',
            name: 'Products',
            component: Products,
            props: true
        },
        {
            path: '/form',
            name: 'Form',
            component: Form,
            props: true
        },
        {
            path: '/purchase-code',
            name: 'PurchaseCode',
            component: FormPurchaseCode
        },
        {
            path: '/logged/',
            name: 'Logged',
            component: Logged
        },
        {
            path: '/logged/:code',
            name: 'Logged',
            component: Logged,
            props: true
        },
        {
            path: '*',
            component: HelloWorld
        }
]
})
